export var ERROR_MSG;
(function (ERROR_MSG) {
    ERROR_MSG["WRONG_FORMAT"] = "Wrong format";
    ERROR_MSG["INVALID_DATE"] = "Date is not valid";
})(ERROR_MSG || (ERROR_MSG = {}));
